import type { Router } from 'vue-router'
import { useUserStoreWithOut } from '/@/store/modules/user'
import { USER_INFO_KEY } from '/@/enums/cacheEnum'

export function createPermissionGuard(router: Router) {
  const userStore = useUserStoreWithOut()
  const loginInfo = JSON.parse(localStorage.getItem(USER_INFO_KEY) || '{}')

  router.beforeEach(async (to, _, next) => {
    if (loginInfo.isLogin) {
      userStore.setUserInfo(loginInfo)
    }
    if (to.name !== 'login' && !userStore.getUserInfo.isLogin) {
      next({ name: 'login', query: { redirect: to.fullPath } })
      return
    }
    next()
  })
}
